import { useQuery } from '@tanstack/react-query'

import { get } from '@/lib/api'

// ==================== Types ====================

export type StatsDeveloperGroup = 'product' | 'design' | 'frontend' | 'backend' | 'testing'

export const DEVELOPER_GROUPS = ['product', 'design', 'frontend', 'backend', 'testing'] as const

export interface WorkloadStatsQuery {
  projectId?: string
  teamId?: string
  startDate?: string
  endDate?: string
}

export interface WorkloadSummary {
  totalTasks: number
  totalEstimatedHours: number
  totalActualHours: number
}

export interface WorkloadMember {
  employeeId: string
  employeeName: string
  developerGroup: StatsDeveloperGroup | null
  taskCount: {
    total: number
    todo: number
    inProgress: number
    done: number
  }
  hours: {
    estimated: number
    actual: number
  }
  isHighWorkload: boolean
}

export interface WorkloadStatsResult {
  summary: WorkloadSummary
  members: WorkloadMember[]
}

// ==================== Query Keys ====================

export const workloadStatsKeys = {
  all: ['workload-stats'] as const,
  stats: (filters: WorkloadStatsQuery) => [...workloadStatsKeys.all, filters] as const,
}

// ==================== Hook ====================

/**
 * 获取工作量统计
 */
export function useWorkloadStats(filters: WorkloadStatsQuery = {}) {
  return useQuery({
    queryKey: workloadStatsKeys.stats(filters),
    queryFn: () =>
      get<WorkloadStatsResult>('/issues/stats/workload', filters as Record<string, unknown>),
  })
}
